﻿
<div class="dsk-wrap" *ngIf="loading">
  <div class="dsk-stat-row">
    <div class="dsk-stat dsk-pulse" *ngFor="let s of [1,2,3,4]"></div>
  </div>
  <div class="dsk-tabs">
    <div class="dsk-tab dsk-pulse"></div>
    <div class="dsk-tab dsk-pulse"></div>
  </div>
  <div class="dsk-card-grid">
    <div class="dsk-card" *ngFor="let c of [1,2,3,4,5,6]">
      <div class="dsk-card-body">
        <div style="display:flex;align-items:center;gap:12px;margin-bottom:8px">
          <div class="dsk-avatar dsk-pulse" style="width:42px;height:42px;border-radius:10px"></div>
          <div style="display:flex;flex-direction:column;gap:6px;flex:1">
            <div class="dsk-cell dsk-pulse" style="width:110px;height:15px"></div>
            <div class="dsk-cell dsk-pulse" style="width:75px;height:11px"></div>
          </div>
        </div>
        <div class="dsk-cell dsk-pulse" style="width:95%;height:11px"></div>
        <div class="dsk-cell dsk-pulse" style="width:70%;height:11px"></div>
      </div>
      <div class="dsk-card-foot">
        <div class="dsk-chip dsk-pulse" style="width:64px"></div>
        <div class="dsk-chip dsk-pulse" style="width:48px"></div>
      </div>
    </div>
  </div>
</div>

<div class="rm-page" *ngIf="!loading">

  <div class="rm-stats">
    <div class="rm-stat rm-stat--red">
      <div class="rm-stat-icon"><mat-icon>shield</mat-icon></div>
      <div class="rm-stat-body">
        <div class="rm-stat-num">{{ totalRoleCount }}</div>
        <div class="rm-stat-label">TOTAL ROLES</div>
        <div class="rm-stat-sub">{{ totalRoleCount }} active · {{ systemRoleCount }} system</div>
      </div>
    </div>
    <div class="rm-stat rm-stat--blue">
      <div class="rm-stat-icon"><mat-icon>groups</mat-icon></div>
      <div class="rm-stat-body">
        <div class="rm-stat-num">{{ totalUserCount }}</div>
        <div class="rm-stat-label">TOTAL USERS</div>
        <div class="rm-stat-sub">{{ adminCount }} admins · {{ managerCount }} managers</div>
      </div>
    </div>
    <div class="rm-stat rm-stat--amber">
      <div class="rm-stat-icon"><mat-icon>manage_accounts</mat-icon></div>
      <div class="rm-stat-body">
        <div class="rm-stat-num">{{ hrCount }}</div>
        <div class="rm-stat-label">HR MEMBERS</div>
        <div class="rm-stat-sub">Managing people operations</div>
      </div>
    </div>
    <div class="rm-stat rm-stat--green">
      <div class="rm-stat-icon"><mat-icon>badge</mat-icon></div>
      <div class="rm-stat-body">
        <div class="rm-stat-num">{{ employeeCount }}</div>
        <div class="rm-stat-label">EMPLOYEES</div>
        <div class="rm-stat-sub">Standard access level</div>
      </div>
    </div>
    <button class="btn-primary rm-create-btn" (click)="openCreateDialog()">
      <mat-icon>add</mat-icon> Create Role
    </button>
  </div>

  <div class="rm-tabs">
    <button class="rm-tab" [class.active]="activeTab==='roles'" (click)="activeTab='roles'">Roles &amp; Permissions</button>
    <button class="rm-tab" [class.active]="activeTab==='users'" (click)="activeTab='users'">Users</button>
  </div>

  <div *ngIf="activeTab==='roles'">
    <div class="roles-grid">
      <div class="role-card" *ngFor="let r of allRolesFlat" (click)="openRoleDrawer(r)">
        <div class="rc-top">
          <div class="rc-icon" [class]="'rc-icon--' + getRoleColor(r.role)">
            <mat-icon>{{ getRoleIcon(r.role) }}</mat-icon>
          </div>
          <button class="rc-edit-btn" (click)="$event.stopPropagation(); openEditDialogFor(r)" matTooltip="Edit">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
          </button>
        </div>
        <div class="rc-name">{{ r.displayName }}</div>
        <div class="rc-desc">{{ r.description || getDefaultDesc(r.role) }}</div>
        <div class="rc-badges">
          <span class="rc-badge rc-badge--menu"><mat-icon>menu</mat-icon> {{ r.menuCount }} menus</span>
          <span class="rc-badge rc-badge--mod"><mat-icon>lock</mat-icon> {{ r.moduleCount }} modules</span>
          <span class="rc-badge rc-badge--active">Active</span>
          <span class="rc-badge rc-badge--system" *ngIf="r.isBuiltIn || r.isSystem">System</span>
        </div>
      </div>
    </div>
    <div *ngIf="allRolesFlat.length === 0" style="text-align:center;padding:60px;color:#a07055">
      <mat-icon style="font-size:48px;width:48px;height:48px;opacity:0.3">admin_panel_settings</mat-icon>
      <div style="font-size:14px;font-weight:700;margin-top:12px">No roles yet</div>
    </div>
  </div>

  <div *ngIf="activeTab==='users'">
    <div class="card" style="margin-top:4px">
      <div *ngIf="employees.length === 0" style="text-align:center;padding:40px;color:#a07055;font-size:12px">No users found</div>
      <div class="tw" *ngIf="employees.length > 0">
        <table>
          <thead>
            <tr><th>Name</th><th>Employee ID</th><th>Email</th><th>Role</th><th>Status</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let emp of employees">
              <td>
                <div style="display:flex;align-items:center;gap:10px">
                  <div class="av" style="width:30px;height:30px;font-size:11px;background:#8b1a1a;color:#fff;border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:700;flex-shrink:0">
                    {{ (emp.firstName||'?').charAt(0) }}{{ (emp.lastName||'?').charAt(0) }}
                  </div>
                  <div>
                    <div style="font-weight:700;font-size:12.5px">{{ emp.firstName }} {{ emp.lastName }}</div>
                    <div style="font-size:10px;color:#a07055">{{ emp.designation || '' }}</div>
                  </div>
                </div>
              </td>
              <td style="font-size:11.5px;color:#a07055">{{ emp.employeeId || '—' }}</td>
              <td style="font-size:11px;color:#a07055">{{ emp.email || '—' }}</td>
              <td>
                <span class="bd" [ngClass]="getRoleBadgeClass(emp.role)" style="font-size:10px">
                  {{ (emp.role || 'employee') | titlecase }}
                </span>
              </td>
              <td>
                <span class="bd" [ngClass]="emp.status === 'active' ? 'bgr' : 'brr'" style="font-size:10px">
                  {{ (emp.status || 'active') | titlecase }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

</div>

<div class="sd-overlay" [class.open]="showRoleDrawer" (click)="showRoleDrawer=false"></div>
<div class="sd-drawer rm-drawer" [class.open]="showRoleDrawer">
  <div class="sd-head" *ngIf="drawerRole">
    <div class="sd-head-info">
      <div class="sd-head-title">{{ drawerRole.displayName }}</div>
      <div class="sd-head-sub">{{ drawerRole.description || getDefaultDesc(drawerRole.role) }}</div>
    </div>
    <button class="sd-close" (click)="showRoleDrawer=false">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
    </button>
  </div>
  <div class="sd-body" *ngIf="drawerRole" style="overflow-y:auto;flex:1">

    <div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:16px">
      <span class="bd bgr" style="font-size:10px">{{ drawerRole.menuCount }} Menus</span>
      <span class="bd bbl" style="font-size:10px">{{ drawerRole.moduleCount }} Modules</span>
      <span class="bd" style="font-size:10px;background:rgba(139,26,26,0.1);color:#8b1a1a;border:none" *ngIf="drawerRole.isBuiltIn || drawerRole.isSystem">System</span>
    </div>

    <div style="font-size:11px;font-weight:700;color:#a07055;letter-spacing:0.5px;margin-bottom:8px">MENU ACCESS</div>
    <div style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:20px">
      <span *ngFor="let m of drawerRole.menuKeys" style="padding:4px 10px;background:rgba(139,26,26,0.07);color:#8b1a1a;border-radius:20px;font-size:11px;font-weight:600">
        {{ getMenuLabel(m) }}
      </span>
      <span *ngIf="!drawerRole.menuKeys || drawerRole.menuKeys.length === 0" style="font-size:11.5px;color:#a07055">No menus assigned</span>
    </div>

    <div style="font-size:11px;font-weight:700;color:#a07055;letter-spacing:0.5px;margin-bottom:8px">MODULE PERMISSIONS</div>
    <div class="rm-perm-table">
      <div class="rm-perm-head">
        <span>Module</span><span>View</span><span>Add</span><span>Edit</span><span>Del</span><span>Scope</span>
      </div>
      <div class="rm-perm-row" *ngFor="let mod of drawerModuleList">
        <span class="rm-perm-mod">{{ mod.label }}</span>
        <span class="rm-perm-cell"><mat-icon [class]="mod.canView ? 'perm-yes' : 'perm-no'">{{ mod.canView ? 'check_circle' : 'cancel' }}</mat-icon></span>
        <span class="rm-perm-cell"><mat-icon [class]="mod.canAdd ? 'perm-yes' : 'perm-no'">{{ mod.canAdd ? 'check_circle' : 'cancel' }}</mat-icon></span>
        <span class="rm-perm-cell"><mat-icon [class]="mod.canEdit ? 'perm-yes' : 'perm-no'">{{ mod.canEdit ? 'check_circle' : 'cancel' }}</mat-icon></span>
        <span class="rm-perm-cell"><mat-icon [class]="mod.canDelete ? 'perm-yes' : 'perm-no'">{{ mod.canDelete ? 'check_circle' : 'cancel' }}</mat-icon></span>
        <span class="rm-perm-scope">{{ mod.scope }}</span>
      </div>
    </div>
  </div>
  <div class="sd-foot" *ngIf="drawerRole">
    <button class="btn-primary" (click)="openEditDialogFor(drawerRole); showRoleDrawer=false">Edit Role</button>
    <button class="btn-outline" (click)="showRoleDrawer=false">Close</button>
  </div>
</div>

<div class="dialog-overlay" *ngIf="showDialog" (click)="closeDialog()">
  <div class="dialog-content large" (click)="$event.stopPropagation()">
    <div class="dialog-header">
      <h3>{{ editingRole ? 'Edit Role' : 'Create Role' }}</h3>
      <button mat-icon-button (click)="closeDialog()"><mat-icon>close</mat-icon></button>
    </div>
    <form (ngSubmit)="submitRole()" class="dialog-form">
      <div class="form-section">
        <h4>Basic Information</h4>
        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>Role Name (key) *</mat-label>
            <input matInput [(ngModel)]="form.name" name="roleName" placeholder="e.g. team_lead" required [disabled]="editingRole?.isSystem">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Display Name *</mat-label>
            <input matInput [(ngModel)]="form.displayName" name="displayName" placeholder="e.g. Team Lead" required>
          </mat-form-field>
        </div>
        <mat-form-field appearance="outline">
          <mat-label>Description</mat-label>
          <input matInput [(ngModel)]="form.description" name="roleDesc" placeholder="Brief description of this role">
        </mat-form-field>
      </div>
      <div class="form-section">
        <div class="section-head">
          <h4>Menu Access</h4>
          <div class="section-actions">
            <button mat-button type="button" (click)="selectAllMenus()">Select All</button>
            <button mat-button type="button" (click)="clearAllMenus()">Clear All</button>
          </div>
        </div>
        <ng-container *ngFor="let grp of menuGroups">
          <div class="menu-group-label">{{ grp }}</div>
          <div class="menu-grid">
            <div *ngFor="let menu of menuItemsByGroup(grp)" class="menu-chip" [class.selected]="isMenuSelected(menu.key)" (click)="toggleMenu(menu.key)">
              <mat-icon>{{ menu.icon }}</mat-icon>
              <span>{{ menu.label }}</span>
              <mat-icon class="check-icon" *ngIf="isMenuSelected(menu.key)">check_circle</mat-icon>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="form-section">
        <h4>Operation Permissions</h4>
        <div class="ops-table">
          <div class="ops-header">
            <span class="ops-module">Module</span>
            <span class="ops-perm">View</span>
            <span class="ops-perm">Add</span>
            <span class="ops-perm">Edit</span>
            <span class="ops-perm">Delete</span>
            <span class="ops-scope">Scope</span>
            <span class="ops-perm">All</span>
          </div>
          <div *ngFor="let mod of operationModules" class="ops-row">
            <span class="ops-module capitalize">{{ mod.replace('_', ' ') }}</span>
            <span class="ops-perm"><mat-checkbox [(ngModel)]="form.operationPermissions[mod].canView"   [name]="mod+'_v'" color="primary"></mat-checkbox></span>
            <span class="ops-perm"><mat-checkbox [(ngModel)]="form.operationPermissions[mod].canAdd"    [name]="mod+'_a'" color="primary"></mat-checkbox></span>
            <span class="ops-perm"><mat-checkbox [(ngModel)]="form.operationPermissions[mod].canEdit"   [name]="mod+'_e'" color="primary"></mat-checkbox></span>
            <span class="ops-perm"><mat-checkbox [(ngModel)]="form.operationPermissions[mod].canDelete" [name]="mod+'_d'" color="primary"></mat-checkbox></span>
            <span class="ops-scope">
              <select [(ngModel)]="form.operationPermissions[mod].scope" [name]="mod+'_scope'" class="scope-select">
                <option *ngFor="let s of scopeOptions" [value]="s">{{ s }}</option>
              </select>
            </span>
            <span class="ops-perm">
              <button mat-icon-button type="button" (click)="toggleAllOps(mod, true)"  matTooltip="Grant all"><mat-icon class="small-icon green-icon">done_all</mat-icon></button>
              <button mat-icon-button type="button" (click)="toggleAllOps(mod, false)" matTooltip="Revoke all"><mat-icon class="small-icon">block</mat-icon></button>
            </span>
          </div>
        </div>
      </div>
      <div class="dialog-actions">
        <button mat-button type="button" (click)="closeDialog()">Cancel</button>
        <button mat-raised-button color="primary" type="submit" [disabled]="submitting">
          {{ submitting ? 'Saving...' : (editingRole ? 'Update Role' : 'Create Role') }}
        </button>
      </div>
    </form>
  </div>
</div>

<div class="dialog-overlay" *ngIf="showSeedDialog" (click)="closeSeedDialog()">
  <div class="dialog-content" (click)="$event.stopPropagation()" style="max-width:500px">
    <div class="dialog-header">
      <h3>Seed Default Roles</h3>
      <button mat-icon-button (click)="closeSeedDialog()"><mat-icon>close</mat-icon></button>
    </div>
    <div style="padding:20px">
      <p style="margin-bottom:16px;color:#6b4a3a">Roles are seeded via SQL script. Use the provided seed SQL to insert default roles into the database.</p>
      <ul style="list-style:none;padding:0;margin:0 0 20px 0">
        <li *ngFor="let r of ['super_admin','admin','hr_admin','hr','manager','employee']" style="padding:8px;background:#faf8f5;margin-bottom:6px;border-radius:4px;display:flex;align-items:center;gap:8px">
          <mat-icon style="color:#8b1a1a;font-size:18px;width:18px;height:18px">verified_user</mat-icon>
          <span style="font-weight:700">{{ r }}</span>
        </li>
      </ul>
    </div>
    <div class="dialog-actions">
      <button mat-button type="button" (click)="closeSeedDialog()">Cancel</button>
      <button mat-raised-button color="primary" (click)="seedDefaultRoles()" [disabled]="seedingRoles">
        {{ seedingRoles ? 'Seeding...' : 'Seed Roles' }}
      </button>
    </div>
  </div>
</div>

